import AdminResetNotice from "./component/AdminResetNotice";

// Self-service reset is off for admins; see AdminResetNotice.
const ForgotPassword = () => <AdminResetNotice title="Forgot your password?" />;

export default ForgotPassword;
